export const PER_REGION_MODES = {
  TAG: 'tag',
  REGION_LIST: 'region-list',
};
